// i18n.jsx - DEPRECATED: This file is no longer needed as we migrated to Jotai atoms
// All i18next functionality has been replaced with useAtom(current_language)

// This file is kept for reference but should be removed in cleanup
export default {};